<template>
  <div class="ace-paper-cont clear-mrg">

    <!-- START: PAGE CONTENT -->

    <div class="padd-box-sm">
      <header class="search-for">
        <h1 class="search-title">search results for:
          <span>Lorem ipsum</span>
        </h1>
      </header>
      <div class="search-result">
        <strong class="title-lg text-upper">nothing found</strong>
        <form class="search-again">
          <div class="form-item-wrap">
            <input class="form-item" id="searchInput" name="searchInput" type="search" placeholder="Search" value=""
              size="30" maxlength="80" required="required">
          </div>
          <div class="form-submit form-item-wrap">
            <input class="btn btn-primary" name="submit" type="submit" id="submit" value="Try Again">
          </div>
        </form>
      </div>
    </div>

    <!-- END: PAGE CONTENT -->

  </div><!-- .ace-paper-cont -->

</template>

<script>
  export default {
    name: 'search',
    data() {
      return {
        msg: 'Welcome to Your Vue.js App'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/search.vue